import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, WritableSignal, booleanAttribute, signal } from '@angular/core';
import { PageComponent } from '../page/page.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { MatMenuModule } from '@angular/material/menu';
import { CrudService } from 'src/app/core/services/crud.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DialogService } from 'src/app/core/services/dialog.service';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import { CrudWszService } from 'src/app/core/services/crud-wsz.service';

@Component({
  selector: 'app-page-detail',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatMenuModule,
    PageComponent,
    MyButtonComponent
  ],
  templateUrl: './page-detail.component.html',
  styleUrl: './page-detail.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageDetailComponent<TData = any> implements OnInit {
  @Input() title?: string;
  @Input() info?: string;
  @Input() id?: number | string;
  @Input() crud?: CrudService<TData> | CrudSentrynelService<TData> | CrudWszService<TData>;
  @Input({ transform: booleanAttribute }) canDelete: boolean = true;
  @Input() model!: TData | undefined;
  @Output() modelChange = new EventEmitter<TData | undefined>();
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();
  @Input() reload?: EventEmitter<any>;
  @Input() checkElaborazione:boolean=false;
  @Output() costumEliminazione = new EventEmitter<string | number>();
  @Output() verifyEliminazione = new EventEmitter<string | number>();
  constructor(
    private readonly fb: FormBuilder,
    private readonly dialog: DialogService,
    private location: Location,
  ) {
    this.form = this.fb.group({});
  }

  get pageInfo() {
    return this.info ?? this.id?.toString();
  }

  ngOnInit() {
    if (this.id && this.crud) {
      this.read(this.id);
    }
    if (this.reload) {
      this.reload.subscribe(() => {
        if (this.id && this.crud) {
          this.read(this.id);
        }
      })
    }
  }

  private read(id: string | number) {
    this.crud!.read(id).subscribe((value) => {
      this.model = value;
      this.modelChange.emit(this.model);
      this.form.patchValue(value as any);
      this.formChange.emit(this.form);
    })
  }

  onDeleteClick() {
    this.dialog.confirm('Elimina', `Il dato sarà eliminato senza possibilità di recupero.`, {
      label: 'Elimina',
      color: 'warn',
      icon: 'delete',
      raised: true
    }).subscribe((result) => {
      this.costumEliminazione.emit()
      if ((result === true) && (this.id)) {
        this.crud?.delete(this.id);
        console.log('qui avverrebbe eliminazione')
        if (this.checkElaborazione) {
          this.verifyEliminazione.emit(this.id)
        }
        else{
          this.location.back();
        }
      }
    })
  }
}
